<template>
    <form-row>
        <div class="flex flex-col sm:flex-row items-start">
            <div class="-mt-4">
                <input-date
                    label="Date"
                    name="final_plat_required_date"
                    v-model="final_plat_required_date"
                    :read_only="read_only"
                    @entered="dateEntered"
                />
            </div>

            <div class="flex-col">
                <div class="pt-3 mt-4 sm:mt-0 flex items-center">
                    <span class="flex-none text-sm text-gray-warm-800 sm:pl-6 pr-6">
                        {{ $t('- OR -') }}
                    </span>

                    <div class="flex-none w-16 sm:w-1/5">
                        <input-text
                            name="final_plat_required_period_after_feasibility"
                            v-model="final_plat_required_period_after_feasibility"
                            placeholder="Days"
                            :read_only="read_only"
                            @input="feasibilityPeriodEntered"
                        />
                    </div>

                    <span class="text-sm text-gray-warm-800 leading-snug pl-4">
                        {{ $t('days after Feasibility / Due Diligence') }}
                    </span>
                </div>

                <div class="pt-3 mt-4 sm:mt-0 flex items-center">
                    <span class="flex-none text-sm text-gray-warm-800 sm:pl-6 pr-6">
                        {{ $t('- OR -') }}
                    </span>

                    <div class="flex-none w-16 sm:w-1/5">
                        <input-text
                            name="final_plat_required_period_before_closing"
                            v-model="final_plat_required_period_before_closing"
                            placeholder="Days"
                            :read_only="read_only"
                            @input="closingPeriodEntered"
                        />
                    </div>

                    <span class="text-sm text-gray-warm-800 leading-snug pl-4">
                        {{ $t('days before Scheduled Closing Date') }}
                    </span>
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
import DateFunctions from '../../../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        commercial: {},
        read_only: { default: false },
    },

    data() {
        return {
            final_plat_required_date: this.commercial.final_plat_required_date,
            final_plat_required_period_after_feasibility: this.commercial.final_plat_required_period_after_feasibility,
            final_plat_required_period_before_closing: this.commercial.final_plat_required_period_before_closing,
        }
    },

    computed: {
        final_plat_required_date_from_period() {
            if (! store.state.feasibility_date && ! store.state.scheduled_closing_date) {
                return;
            }

            if (this.final_plat_required_period_after_feasibility) {
                if (this.isValidDate(store.state.feasibility_date)) {
                    return dayjs(store.state.feasibility_date.slice(0, 10))
                        .add({ day: this.final_plat_required_period_after_feasibility })
                        .format('YYYY-MM-DD')
                } else {
                    return null;
                }
            }

            if (this.isValidDate(store.state.scheduled_closing_date)
                && this.final_plat_required_period_before_closing
            ) {
                return dayjs(store.state.scheduled_closing_date.slice(0, 10))
                    .subtract({ day: this.final_plat_required_period_before_closing })
                    .format('YYYY-MM-DD')
            }
        },
    },

    methods: {
        dateEntered() {
            this.final_plat_required_period_after_feasibility = null;
            this.final_plat_required_period_before_closing = null;
        },
        feasibilityPeriodEntered(value) {
            if (! value || ! store.state.feasibility_date) {
                this.final_plat_required_date = null;
            }

            this.final_plat_required_period_before_closing = null;
        },
        closingPeriodEntered(value) {
            if (! value || ! store.state.entitlement_date) {
                this.scheduled_closing_date = null;
            }

            this.final_plat_required_period_after_feasibility = null;
        },
    },

    watch: {
        final_plat_required_date_from_period(val) {
            if (val) {
                this.final_plat_required_date = val;
            }
        },
        final_plat_required_date(val) {
            this.$emit('updated', val);
        },
    },
}
</script>
